import $ from "jquery";
import "../../../node_modules/slick-carousel/slick/slick";

const advantageSliderPlayer = () => {
  const init = () => {
    advantageSlider();
  };

  const advantageSlider = () => {
    const el = {
      sliderImage: "div.advantageSlider-image-slick",
      sliderContent: "div.advantageSlider-content-slick",
    };

    const imageSetting = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: ".advantageSlider-content-slick",
    };

    const contentSetting = {
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      asNavFor: ".advantageSlider-image-slick",
      dots: true,
      centerMode: true,
      focusOnSelect: true,
      prevArrow: false,
      nextArrow: $(el.sliderImage),
    };

    $(el.sliderImage).slick(imageSetting);
    $(el.sliderContent).slick(contentSetting);
  };

  init();
};

try {
  advantageSliderPlayer();
} catch (error) {
  console.log(error);
}
